import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Layout/Header";
import { LanguageContext } from "../context/LanguageContext";
import "./privacyPolicyDindori.css";

const translations = {
  en: {
    header: "Privacy Policy — Dindori Pranit Seva Marg",
    breadcrumbHome: "Home",
    lastUpdated: "Last Updated: October 2025",
    intro: `We, at Dindori Pranit Shree Swami Samarth Seva Marg, value your trust and respect your privacy. 
This privacy policy explains how we collect, use, and safeguard your information when you visit our website or participate in our seva activities.`,
    sections: [
      {
        title: "1. Information We Collect",
        content: `We may collect information such as your name, phone number, email, and location when you fill out forms, subscribe to newsletters, or participate in donations and events.`
      },
      {
        title: "2. How We Use Your Information",
        content: `The information you provide is used only to communicate updates, manage seva or donation records, improve our website experience, and ensure transparency in all organizational activities.`
      },
      {
        title: "3. Data Security",
        content: `We implement appropriate administrative, physical, and technical safeguards to protect your personal data from unauthorized access or misuse.`
      },
      {
        title: "4. Cookies Policy",
        content: `Our website may use cookies to improve functionality and analyze user behavior. You may disable cookies from your browser settings if you wish.`
      },
      {
        title: "5. Third-Party Links",
        content: `Our website may contain links to other websites. We are not responsible for their privacy practices and encourage you to review their policies separately.`
      },
      {
        title: "6. Your Rights",
        content: `You may contact us anytime to update, correct, or delete your personal information stored with us.`
      },
      {
        title: "7. Returns and refunds for donations",
        content: `Policy: Donations are considered final and will not be refunded.
Note: This policy applies to all forms of donations, including cash and online payments. In case of any disputes, they will be settled according to the norms of the payment gateway service provider.`
      },
      {
        title: "8. Contact Us",
        content: `If you have any concerns about this Privacy Policy, please contact us at: 

Pradhan Seva Kendra, Shri Kshetra Dindori
Shri Swami Samarth Seva & Spiritual Development Center
Dindori, Taluka: Dindori, District: Nashik – 422202
Email: contact@ma.dindoripranit.org

Akhil Bharatiya Shree Swami Samarth Gurupeeth
Trimbakeshwar, Nashik, Maharashtra, India – 422212
Email: info@gurupeeth.in
`
      }
    ],
  },
  mr: {
    header: "गोपनीयता धोरण — दिंडोरी प्रणीत सेवा मार्ग",
    breadcrumbHome: "मुख्यपृष्ठ",
    lastUpdated: "शेवटचे अद्यतन: ऑक्टोबर २०२५",
    intro: `आम्ही, दिंडोरी प्रणीत श्री स्वामी समर्थ सेवा मार्ग, आपल्या विश्वासाचे मोल जाणतो आणि आपल्या गोपनीयतेचा आदर करतो.
हे धोरण आमच्या संकेतस्थळावर भेट दिल्यावर किंवा सेवेच्या उपक्रमांमध्ये सहभागी झाल्यावर आपली माहिती कशी संकलित, वापरली आणि सुरक्षित ठेवली जाते हे स्पष्ट करते.`,
    sections: [
      {
        title: "१. आम्ही कोणती माहिती गोळा करतो",
        content: `जेव्हा आपण फॉर्म भरता, वृत्तपत्राची सदस्यता घेता किंवा दान/सेवा उपक्रमांमध्ये सहभागी होता तेव्हा आपले नाव, दूरध्वनी क्रमांक, ईमेल आणि स्थान यासारखी माहिती गोळा केली जाऊ शकते.`
      },
      {
        title: "२. माहितीचा उपयोग कसा करतो",
        content: `आपण दिलेली माहिती केवळ संवाद साधण्यासाठी, सेवा किंवा दान नोंदी व्यवस्थापित करण्यासाठी, संकेतस्थळाचा अनुभव सुधारण्यासाठी आणि पारदर्शकता राखण्यासाठी वापरली जाते.`
      },
      {
        title: "३. डेटा सुरक्षा",
        content: `आपली वैयक्तिक माहिती अनधिकृत प्रवेश किंवा गैरवापरापासून सुरक्षित ठेवण्यासाठी आम्ही प्रशासकीय, भौतिक आणि तांत्रिक उपाययोजना लागू केल्या आहेत.`
      },
      {
        title: "४. कुकीज धोरण",
        content: `संकेतस्थळावर कुकीजचा वापर कार्यक्षमता वाढविण्यासाठी आणि वापरकर्त्यांच्या वर्तनाचे विश्लेषण करण्यासाठी केला जाऊ शकतो. आपण इच्छित असल्यास आपल्या ब्राउझरमधून कुकीज अक्षम करू शकता.`
      },
      {
        title: "५. तृतीय पक्ष दुवे",
        content: `आमच्या संकेतस्थळावर इतर वेबसाइट्सचे दुवे असू शकतात. त्यांच्या गोपनीयता पद्धतींसाठी आम्ही जबाबदार नाही. कृपया त्यांच्या धोरणांचा स्वतंत्रपणे आढावा घ्या.`
      },
      {
        title: "६. आपले हक्क",
        content: `आपण आपल्या वैयक्तिक माहितीचे अद्यतन, सुधारणा किंवा विलोपन करण्यासाठी कधीही आमच्याशी संपर्क साधू शकता.`
      },
      {
        title: "७. देणग्यांसाठी परतफेड",
        content: `धोरण :  देणग्या अंतिम मानल्या जातात आणि परत केल्या जाणार नाहीत. टीप: ही धोरण रोख आणि ऑनलाइन पेमेंटसह सर्व प्रकारच्या देणग्यांना लागू होते. कोणत्याही वादाच्या बाबतीत, ते पेमेंट गेटवे सेवा प्रदात्याच्या नियमांनुसार सोडवले जातील.`
      },
      
      {
        title: "८. संपर्क माहिती",
        content: `या गोपनीयता धोरणाबद्दल काही शंका असल्यास, कृपया आमच्याशी संपर्क साधा: 

अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ
त्र्यंबकेश्वर, नाशिक, महाराष्ट्र, भारत – ४२२२१२
ईमेल: info@gurupeeth.in

प्रधान सेवा केंद्र, श्री क्षेत्र दिंडोरी
श्री स्वामी समर्थ सेवा आणि अध्यात्मिक विकास केंद्र
दिंडोरी, ता. दिंडोरी, जि. नाशिक – ४२२२०२
ईमेल: contact@ma.dindoripranit.org`
      }
    ],
  }
};

export default function PrivacyPolicyDindori() {
  const { lang } = useContext(LanguageContext);
  const t = translations[lang];

  return (
    <div className="privacy-page">
      <Header />

      <div className="privacy-header-wrapper">
        <header className="privacy-header">
          <div className="header-center">
            <div className="breadcrumb">
              <Link to="/">{t.breadcrumbHome}</Link> &gt; <span>{t.header}</span>
            </div>
            <h1>{t.header}</h1>
            <p className="last-updated">{t.lastUpdated}</p>
          </div>
        </header>
      </div>

      <main className="privacy-main">
        <section className="privacy-intro">
          <p>{t.intro}</p>
        </section>

        <section className="privacy-sections">
          {t.sections.map((section, index) => (
            <div key={index} className="privacy-section">
              <h2>{section.title}</h2>
              <p style={{ whiteSpace: "pre-line" }}>{section.content}</p>
            </div>
          ))}
        </section>
      </main>
    </div>
  );
}
